export default __webpack_public_path__ + "static/media/thumbnail.0059dd4d.webp";